var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndication(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4482 10C19.4482 15.2479 15.2053 19.5 9.9741 19.5C4.74292 19.5 0.5 15.2479 0.5 10C0.5 4.75207 4.74292 0.5 9.9741 0.5C15.2053 0.5 19.4482 4.75207 19.4482 10Z",
    fill: "#E9EFFA",
    stroke: "#285FCB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9896 4.75781L10.7802 11.1753H9.25673L9.04091 4.75781H10.9896ZM8.99013 13.1621C8.99013 12.8913 9.08323 12.667 9.26942 12.4893C9.45985 12.3073 9.70953 12.2163 10.0184 12.2163C10.3316 12.2163 10.5813 12.3073 10.7675 12.4893C10.9537 12.667 11.0468 12.8913 11.0468 13.1621C11.0468 13.4245 10.9537 13.6466 10.7675 13.8286C10.5813 14.0106 10.3316 14.1016 10.0184 14.1016C9.70953 14.1016 9.45985 14.0106 9.26942 13.8286C9.08323 13.6466 8.99013 13.4245 8.99013 13.1621Z",
    fill: "#285FCB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndication);
export default __webpack_public_path__ + "static/media/indication.0155c813.svg";
export { ForwardRef as ReactComponent };